export enum RequestType {
  CLIENT,
  IP,
  COMPANY,
  SHARE_FILE
}

export const RequestTypes = [
  {
    value: RequestType[RequestType.CLIENT],
    label: '클라이언트신청'
  },
  {
    value: RequestType[RequestType.IP],
    label: '아이피신청'
  },
  {
    value: RequestType[RequestType.COMPANY],
    label: '그룹신청'
  },
  {
    value: RequestType[RequestType.SHARE_FILE],
    label: '파일공유신청'
  }
];